import Layout from "./Layout";
import Modal from "./Modal";
import { OnLoad } from "./OnLoadWrapper";
import Relative from "./Relative";
import Section from "./Section";

const containers = { Layout, Section, Relative, Modal, OnLoad };
export default containers;
